import { render, staticRenderFns } from "./jobs-results.vue?vue&type=template&id=80ecabfa&lang=html&"
import script from "./jobs-results.vue?vue&type=script&lang=js&"
export * from "./jobs-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports